import React from 'react';
import QuantityField from './QuantityField';
var OrderedQuantity = function (_a) {
    var value = _a.value, onChange = _a.onChange, _b = _a.min, min = _b === void 0 ? 0 : _b, max = _a.max, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.outRangeBehavior, outRangeBehavior = _d === void 0 ? {
        max: {
            type: 'disabled',
            message: '',
        },
        min: {
            type: 'disabled',
            message: '',
        },
    } : _d;
    var handleChange = React.useCallback(function (value) { return onChange(value ? value : 0); }, [onChange]);
    return (React.createElement(QuantityField, { value: value, onChange: handleChange, min: min, max: max, ariaLabel: 'orderedQuantity', disabled: disabled, outRangeBehavior: outRangeBehavior }));
};
export default OrderedQuantity;
